import List from "@mui/material/List";
import { useCartContext } from "vino/context";
import OrderProductItem from "./OrderProductItem";
import OrderSummaryFooter from "./OrderSummaryFooter";

const OrderProductTable = () => {
	const { cartLineItems } = useCartContext();

	return (
		<List className="p-0">
			{cartLineItems.map((item) => (
				<OrderProductItem key={item.variantId} lineItem={item} />
			))}
			<OrderSummaryFooter />
		</List>
	);
};

export default OrderProductTable;
